import React from 'react';

const WidgetItensDisponiveis = ({ items }) => {
  // Agrupa itens com o mesmo nome e soma o saldo
  const aggregatedItems = items.reduce((acc, item) => {
    // Procura se já existe um item com o mesmo nome no acumulador
    const existingItem = acc.find(i => i.nome === item.nome);
    const saldoItem = Number(item.saldo) || 0;
    if (existingItem) {
      existingItem.saldo = Number(existingItem.saldo) + saldoItem;
    } else {
      // Faz uma cópia do item e garante que saldo seja numérico
      acc.push({ ...item, saldo: saldoItem });
    }
    return acc;
  }, []);

  // Calcula o valor máximo (usado para o progress bar) com base nos itens agrupados
  const maxQuantity = aggregatedItems.reduce((max, item) => {
    return item.saldo > max ? item.saldo : max;
  }, 0);

  // Recalcula a porcentagem para cada item agrupado
  let finalItems = aggregatedItems.map(item => {
    const percent = maxQuantity > 0 ? (item.saldo / maxQuantity) * 100 : 0;
    return { ...item, percent };
  });

  // Ordena os itens do maior para o menor saldo
  finalItems.sort((a, b) => b.saldo - a.saldo);
  finalItems = finalItems.slice(0, 5);

  return (
    <div className="col-md-6 col-lg-4">
      <div className="card">
        <div className="card-header">
          <h3 className="card-title">Itens Disponíveis</h3>
        </div>
        <table className="table card-table table-vcenter">
          <thead>
            <tr>
              <th>Item</th>
              <th colSpan="2">Quantidade</th>
            </tr>
          </thead>
          <tbody>
            {finalItems && finalItems.length > 0 ? (
              finalItems.map((item, index) => (
                <tr key={index}>
                  <td>{item.nome}</td>
                  <td>{Math.floor(item.saldo)}</td>
                  <td className="w-50">
                    <div className="progress progress-xs">
                      <div
                        className="progress-bar bg-primary"
                        style={{ width: `${Math.floor(item.percent)}%` }}
                      ></div>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" className="text-center">
                  Nenhum item encontrado.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default WidgetItensDisponiveis;